import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { UtilitiesProvider } from './utilities';
import { ENV } from '@app/env';
import { isObject, findIndex } from 'lodash';
import * as firebase from 'firebase';
@Injectable()
export class TicketData {

  constructor(
    private afDb: AngularFireDatabase,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private utilities: UtilitiesProvider
  ) { }

  public getTicketList(): Observable<any[]> {
    return this.afDb.list(`Clients/${ENV.client}/Ticket`, ref => ref.orderByChild('state').equalTo(true)).valueChanges();
  }

  public getTicket(ticketId: string): Observable<any> {
    return this.afDb.object(`/Clients/${ENV.client}/Ticket/${ticketId}`).valueChanges();
  }

  public getTicketSnapById(ticketId: string): Promise<any> {
    return this.afDb.object(`/Clients/${ENV.client}/Ticket/${ticketId}`)
      .query.once('value');
  }

  public getUserShoppingCart(userId: string): Observable<any> {
    return this.afDb.object(`/Clients/${ENV.client}/UserTicketShoppingCart/${userId}`).valueChanges();
  }

  public createTicketForPayMantence(fees, userId, userEmail) {
    const id = this.afDb.createPushId();
    return this.afDb.object(`/Clients/${ENV.client}/Ticket/${id}`).set({
      isPayFeed: false,
      month_fees: fees.month,
      year_fees: fees.year,
      idFees: fees.id,
      type: 'maintenance',
      label: {
        es: fees.label,
        en: ""
      },
      description: {
        es: fees.descripccion + ' ' + userEmail,
        en: "",
      },
      price: fees.valor,
      created_at: firebase.database.ServerValue.TIMESTAMP,
      id,
      state: true,
      stock: 1,
      min_per_user: 1,
      max_per_user: 1,
      userIdTicket: userId
    }).then(() => id);
  }

  public getUserShoppingCartSnap(userId: string): Promise<any> {
    return this.afDb.object(`/Clients/${ENV.client}/UserTicketShoppingCart/${userId}`)
      .query.once('value');
  }

  public addFormToTicket(userId: string, sale_form_user_data: any, ticketId: string): Promise<any> {
    return this.afDb.object(`/Clients/${ENV.client}/UserTicketShoppingCart/${userId}/tickets/${ticketId}`)
      .update({ sale_form_user_data });
  }

  public addTicketToShoppingCart(userId: string, ticket: any, amount: number) {
    return this.getUserShoppingCartSnap(userId)
      .then(snap => snap.val())
      .then(cart => {
        if (cart) {
          let ticketShopping = findIndex(cart.tickets, ['id', ticket.id]);
          if (ticketShopping !== -1) {
            cart.tickets[ticketShopping].sale_price = ticket.price;
            cart.tickets[ticketShopping].sale_amount = amount;
          } else {
            ticket.sale_amount = amount;
            ticket.sale_price = ticket.price;
            cart.tickets[ticket.id] = ticket;
          }
        } else {
          ticket.sale_amount = amount;
          ticket.sale_price = ticket.price;
          cart = {
            state: 'pending',
            created_at: new Date().getTime(),
            tickets: { [ticket.id]: ticket },
          };
        }
        return cart;
      })
      .then(cart => {
        if (isObject(cart)) {
          // Esta actualizacion dispara la funcion que recalcula valores y descuentos del carrito de compra
          this.afDb.object(`/Clients/${ENV.client}/UserTicketShoppingCart/${userId}`)
            .update({ ...cart, isLoad: true });
        }
        return cart;
      })
      .then((cart) => cart)
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/ticket.ts